/**
 * @generated SignedSource<<65e2feaeb93f6b005214c3b20e82d66e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskFirstLabelingDifferenceCounterLabel_difference$data = {
  readonly answer?: {
    readonly __typename: "Diff";
  } | null;
  readonly answerChoiceCount?: {
    readonly __typename: "Diff";
  } | null;
  readonly answerType?: {
    readonly __typename: "Diff";
  } | null;
  readonly difficulty?: {
    readonly __typename: "Diff";
  } | null;
  readonly problem?: {
    readonly __typename: "Diff";
  } | null;
  readonly solution?: {
    readonly __typename: "Diff";
  } | null;
  readonly unitDs?: ReadonlyArray<{
    readonly __typename: "Diff";
  }> | null;
  readonly " $fragmentType": "TaskFirstLabelingDifferenceCounterLabel_difference";
};
export type TaskFirstLabelingDifferenceCounterLabel_difference$key = {
  readonly " $data"?: TaskFirstLabelingDifferenceCounterLabel_difference$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskFirstLabelingDifferenceCounterLabel_difference">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskFirstLabelingDifferenceCounterLabel_difference",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "difficulty",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "unitDs",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "problem",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "solution",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "answer",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "answerChoiceCount",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "answerType",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "type": "TaskFirstLabelingDifference",
      "abstractKey": null
    }
  ],
  "type": "Difference",
  "abstractKey": "__isDifference"
};
})();

(node as any).hash = "36ca83f3d2cfce6bce3f5f1cc9a7c5fe";

export default node;
